<template>
	<div class="my-resume" v-if="data.mberSeq">
		<div class="photo">
			<file-select v-if="data.gender == 'M'" type="image" v-model="profileImg" :src="'/api/mem/prf/profile?tecMberSeq=' + data.mberSeq" defaultSrc="PROFILE" @input="saveProfile" :disabled="!auth('작성자')"/>
			<file-select v-if="data.gender == 'F'" type="image" v-model="profileImg" :src="'/api/mem/prf/profile?tecMberSeq=' + data.mberSeq" defaultSrc="PROFILE_W" @input="saveProfile" :disabled="!auth('작성자')"/>
			<template v-if="auth('작성자')">이미지 미첨부시<br/>기본이미지로 저장됩니다.</template>
		</div>
		<div class="info-text" v-if="auth('작성자')">
			※ 기본사항은 ‘개인정보관리’에서 변경 하실 수 있습니다.
			<div class="personal-info_btn" @click="$router.push({name: 'MYP102M01'})">
				개인정보관리 &#9654;
			</div>
		</div>
		<!-- 프로필 -->
		<div class="info" ref="profile">
			<div class="Board" style="margin-bottom: 0;margin-top: 0;">
				<table class="Board_type2" style="table-layout: auto;">
					<colgroup>
						<col width="140">
						<col width="500">
						<col width="*">
					</colgroup>
					<tbody>
						<tr>
							<th>성명</th>
							<td><InputComp type="text" v-model="data.mberNm" readonly/></td>
						</tr>
						<tr>
							<th>생년월일</th>
							<td><InputComp type="date" v-model="data.birthYyyymmdd" format="yyyy년 MM월 dd일" readonly/></td>
						</tr>
						<tr>
							<th>이메일</th>
							<td><InputComp type="text" v-model="data.email" readonly/></td>
						</tr>
						<tr>
							<th>핸드폰번호</th>
							<td><InputComp type="phone" v-model="data.hpNo" readonly/></td>
						</tr>
						<tr>
							<th>성별</th>
							<td><InputComp type="gender" classNm="gender" :value="data.gender" readonly /></td>
						</tr> 	
					</tbody>
				</table>
			</div>
		</div>

		<template v-if="auth('관리자') && !admModifyYn">
			<div class="modifyBtnArea">
				<img src="/images/admin/btn_resume_modify.png" @click="admModify()"/>
			</div>
		</template>

		<template>
			<div v-if="auth('관리자') ? admMdf : true" class="atchResmFile">
				<p :class="auth('관리자') ? 'resmRegi-tit' : ''">이력서 자동 등록 서비스</p>
				<div class="step-indicator">
					<div v-if="!auth('관리자')" class="step-item" data-step="1" :class="stepItem == 1 ? 'active' : 'pending'" @click="changeStep(1)">
						<div class="step-dot"></div>
						<span>KOSA 연동</span>
					</div>
					<div v-else class="step-item pending disabled" data-step="1">
						<div class="step-dot"></div>
						<span>KOSA 연동</span>
					</div>
					<div class="step-item" data-step="2" :class="stepItem == 2 ? 'active' : 'pending'" @click="changeStep(2)">
						<div class="step-dot"></div>
						<span>템플릿 등록</span>
					</div>
					<div class="step-item" data-step="3" :class="stepItem == 3 ? 'active' : 'pending'" @click="changeStep(3)">
						<div class="step-dot"></div>
						<span>등록 대행</span>
					</div>
				</div>
				<div class="step-content" :class="stepItem == 1 ? 'active' : ''">
					<div class="description">
						KOSA 경력관리 시스템의 정보를 자동으로 불러와 등록합니다.
					</div>
					
					<div class="kosa-form">
						<div class="form-row">
							<div class="form-group">
								<label for="kosa-id">KOSA 아이디</label>
								<InputComp type="text" class="step-input" v-model="kosaData.kosaId" placeholder="아이디"/>
							</div>
							<div class="form-group">
								<label for="kosa-password">KOSA 비밀번호</label>
								<InputComp type="password" class="step-input" v-model="kosaData.kosaPw" title="비밀번호" placeholder="비밀번호"/>
							</div>
							<button class="btn-submit" @click="searchKOSA()">정보 불러오기</button>
						</div>
						
						<div class="warning-notice">
							<div class="warning-text">
								<span class="warning-icon">※</span> <strong>KOSA에서 연동되지 않는 정보는 추가 입력이 필요하며, 상세할수록 정확한 등급 산정과 우선 배치 기회를 받으실 수 있습니다.</strong>
							</div>
						</div>
					</div>
					
					<div class="bottom-notice">
						<div class="bottom-text">
							정확한 전문성 평가를 위해 경력 증빙 자료나 추가 정보 제출을 요청드릴 수 있으며 필요시 개별 연락을 통해 안내해드립니다.<br/>체계적인 검증을 통해 프로님께 최적의 기회를 연결해드리겠습니다.
						</div>
					</div>
				</div>

				<!-- Step 2: 템플릿 등록 -->
				<div class="step-content" :class="stepItem == 2 ? 'active' : ''">
					<div class="description">
						<!-- 제공된 액셀 템플릿에 정보 입력 후 업로드하면 자동 등록됩니다. -->
						 템플릿에 입력한 정보는 현재 페이지 정보와 함께 누적되어 등록됩니다.<br/>페이지에 입력된 내용과 다른 정보만 템플릿에 작성해주세요.
					</div>
					
					<div class="kosa-form">
						<div class="upload-section">
							<div class="upload-icon"></div>
							<div class="upload-title">템플릿 파일 업로드</div>
							<div class="upload-desc">템플릿 다운로드 후 작성하여 업로드해주세요</div>
							
							<div class="btn-group">
								<button class="btn-download" @click="$.fileDownload('/files/tech/prf/GreatPro_이력서양식v1.0.2.xlsx')">템플릿 다운로드</button>
								<!-- <button class="btn-upload">파일 업로드</button> -->
								<file-select classNm="btn-upload" type="button" title="excelUpload" buttonText="파일 업로드" v-model="temp.excelFile" accept=".xls,.xlsx" @input="excelUpload"/>
							</div>
						</div>
						
						<div class="warning-notice">
							<div class="warning-text">
								<span class="warning-icon">※</span> <strong>상세한 경력 정보와 기술 스택을 빠짐없이 작성하실수록 정확한 등급 산정과 우선 배치 기회를 받으실 수 있습니다.</strong>
							</div>
						</div>
					</div>
					
					<div class="bottom-notice">
						<div class="bottom-text">
							정확한 전문성 평가를 위해 경력 증빙 자료나 추가 정보 제출을 요청드릴 수 있으며 필요시 개별 연락을 통해 안내해드립니다.<br/>체계적인 검증을 통해 프로님께 최적의 기회를 연결해드리겠습니다.
						</div>
					</div>
				</div>

				<!-- Step 3: 등록 대행 - 사용자 -->
				<!-- <div v-if="!auth('관리자') && data.lastAttaFileSeq == undefined" class="step-content" :class="stepItem == 3 ? 'active' : ''">
					<div class="description">
						기존 이력서 파일을 업로드하시면 전문 담당자가 대신 입력해드립니다.
					</div>
					
					<div class="kosa-form">
						<div class="file-upload-section">
							<div class="file-icon-add"></div>
							<div class="upload-title">이력서 파일 업로드</div>
							<div class="upload-desc">PDF, Word, 이미지 형태 가능 (2~3일 소요)</div> -->
							
							<!-- <button class="btn-file-select">파일 선택</button> -->
							<!-- <file-select classNm="btn-upload" type="button" title="excelUpload" buttonText="파일 선택" v-model="temp.resmFile" accept=".xlsx,.xls,doc,.docx,.pdf" @input="resmFileUpload"/>
						</div>
						
						<div class="warning-notice">
							<div class="warning-text">
								<span class="warning-icon">※</span> <strong>상세한 경력 정보와 기술 스택을 빠짐없이 제공해주실수록 정확한 등급 산정과 우선 배치 기회를 받으실 수 있습니다.</strong>
							</div>
						</div>
					</div>
					
					<div class="bottom-notice">
						<div class="bottom-text">
							정확한 전문성 평가를 위해 경력 증빙 자료나 추가 정보 제출을 요청드릴 수 있으며 필요시 개별 연락을 통해 안내해드립니다.<br/>체계적인 검증을 통해 프로님께 최적의 기회를 연결해드리겠습니다.
						</div>
					</div>
				</div> -->

				<!-- Step 3: 등록 대행 - 관리자 -->
				<!-- <div v-if="auth('관리자') || data.lastAttaFileSeq != undefined" class="step-content" :class="stepItem == 3 ? 'active' : ''"> -->
				<div class="step-content" :class="stepItem == 3 ? 'active' : ''">
					<div class="description">
						<span v-if="!auth('관리자')">보유한 이력서 파일을 업로드하시면 <br>담당 매니저가 그레이트 프로 양식에 맞춰 입력해드립니다.</span>
						<span v-else>IT 프로가 업로드한 이력서 파일을 확인하고 다운로드할 수 있습니다.</span>
					</div>
					
					<div class="kosa-form">
						<div class="file-upload-section" v-if="!auth('관리자') && data.lastAttaFileSeq == undefined">
							<div class="file-icon-add"></div>
							<div class="upload-title">이력서 파일 업로드</div>
							<div class="upload-desc">PDF, Word, Excel 형태 가능 (3~5일 소요)</div>
							
							<!-- <button class="btn-file-select">파일 선택</button> -->
							<file-select classNm="btn-upload" type="button" title="excelUpload" buttonText="파일 선택" v-model="temp.resmFile" accept=".xlsx,.xls,doc,.docx,.pdf" @input="resmFileUpload"/>
						</div>
						<div class="file-list-section" v-if="auth('관리자') || (!auth('관리자') && data.lastAttaFileSeq != undefined)">
							<div class="file-list">
								<div class="file-item">
									<div class="file-info">
										<div class="file-icon"></div>
										<div class="file-details">
											<!-- 업로드 파일이 있는 경우  -->
											<template v-if="data.lastAttaFileSeq != undefined">
												<div class="file-name">{{ data.lastAttaFileNm }}</div>
												<div class="file-meta">업로드일: {{data.lastAttaFileRegDate | date('yyyy.MM.dd')}}</div>
											</template>
											<!-- 업로드 파일 없을 때(관리자) -->
											 <span v-else> 등록된 파일이 없습니다.</span>
										</div>
									</div>
								<div class="btn-group">	
									<button class="download-adm-btn" v-if="auth('관리자') && data.lastAttaFileSeq != undefined" @click="clickAttaFileAdm()">다운로드</button>
									<button class="btn-resumDel" v-if="data.lastAttaFileSeq != undefined" @click="delResmAgncFile(data.lastAttaFileSeq)">파일 삭제</button>
									<file-select classNm="btn-upload" type="button" title="excelUpload" buttonText="파일 선택" v-model="temp.resmFile" accept=".xlsx,.xls,doc,.docx,.pdf" @input="resmFileUpload"/>
								</div>
							</div>

							<!-- <div class="file-list" v-else-if="auth('관리자')">
									<span> 등록된 파일이 없습니다.</span>
								</div> -->
							</div>

							<div class="upload-notice" v-if="auth('관리자')">
								업로드된 파일: IT 프로가 제출한 이력서 파일을 검토 후 관련 문서를 첨부할 수 있습니다.<br/>
								각 파일을 다운로드하여 상세 정보를 검토한 후 시스템에 직접 입력하거나 수정하실 수 있습니다.
							</div>
						</div>

						<div class="warning-notice" v-if="!auth('관리자')">
							<div class="warning-text">
								<span class="warning-icon">※</span> <strong>상세한 경력 정보와 기술 스택을 빠짐없이 제공해주실수록 정확한 등급 산정과 우선 배치 기회를 받으실 수 있습니다.</strong>
							</div>
						</div>

						<div class="additional-info" v-if="auth('관리자')">
							<div class="info-text">
								<span class="info-icon">※</span> <strong>파일 검토 후 추가 정보가 필요하거나 정정이 필요한 내용이 있을 경우 IT프로에게 처리 지원을 요청할 수 있습니다.</strong>
							</div>
						</div>
					</div>
					
					<div class="bottom-notice">
						<div class="bottom-text">
							정확한 전문성 평가를 위해 경력 증빙 자료나 추가 정보 제출을 요청드릴 수 있으며 필요시 개별 연락을 통해 안내해드립니다.<br/>체계적인 검증을 통해 프로님께 최적의 기회를 연결해드리겠습니다.
						</div>
					</div>
				</div>

			</div>
		</template>

		<!-- <template v-if="auth('작성자') || auth('관리자')">
			<div class="atchResmFile"> -->
				<!-- <img src="/images/admin/resume_reg_agency.png" class="regiAgency"> -->
				<!-- <p :class="auth('관리자') ? 'resmRegi-tit' : ''">이력서 자동 등록대행 서비스</p>
				<div class="atchFileArea">
					<template v-if="auth('관리자')">
						<InputComp title="파일명" v-model="data.lastAttaFileNm" classNm="fileName" :readonly="true"/>
						<img src="/images/admin/btn_resume_down_new.png" @click="resmAtchPup">
					</template>
					<template v-else-if="auth('작성자')">
						<file-select type="file" title="excelUpload" v-model="temp.resmFile" accept=".xlsx,.xls,doc,.docx,.pdf" @input="resmFileUpload"/>
					</template>
				</div>
				<div v-if="auth('작성자')" class="kosa-btn"  @click="searchKOSA()">
					KOSA 경력관리 자동입력
					<span><img src="/images/kosa_icon.png"></span>
				</div>
				<p v-if="auth('작성자')" class="ref">
					<span>‘본인의 이력서 파일’ 을 업로드하시면, 회원님의 이력서를 그레이트 프로 이력서 양식에 맞게 자동 등록해 드립니다. </span>
					자동 등록된 이력서는 신속하게 면접 제안을 받을 가능성이 훨씬 높습니다.  
				</p>
			</div>
		</template> -->
		
		<!-- 이력서 파일 업로드 -->
		<!-- <template v-if="(auth('관리자'))">
			<div class="filebox">
				<p>엑셀 이력서 양식 다운로드 및 업로드</p>
				<img class="excel_download" src="/images/tec/prf/excel_download.png" alt="엑셀양식다운로드" @click="$.fileDownload('/files/tech/prf/GreatPro_이력서양식v1.0.2.xlsx')"/>
				<file-select type="file" title="excelUpload" v-model="temp.excelFile" accept=".xls,.xlsx" @input="excelUpload"/> -->
				<!-- <div class="kosabox">
					<img v-if="auth('관리자')" src="/images/tec/prf/kosa_btn.png" alt="코사자동입력" />
					<img v-else src="/images/tec/prf/kosa_btn.png" alt="코사자동입력" @click="searchKOSA()"/>
				</div> -->
				<!-- <p class="excel_download_notice"><span>'엑셀 양식 다운로드'</span> 후 작성하여 파일을 업로드하시면, 하단 이력서 항목에 자동 입력됩니다.</p>
			</div> -->

			<!-- <div class="filebox-line"></div> -->

			<!-- <div class="filebox-notice">
				<span style="font-weight : bold; color:#000000 ">※ 이력서 파일을 업로드 하시면, 아래 이력서 항목에 자동 입력되며, 화면상에서 추가 및 수정을 하실 수 있습니다.</span>
				<br/>※ 이력서 파일은 다운로드한 양식(엑셀)으로 작성하여 업로드 바랍니다. (첨부파일 크기 제한 : 10MB)
			</div>
		</template> -->

		<!-- 자기소개 -->
		<div class="resume-box" ref="seflIntro">
			<div class="tit">자기소개<br/><span>※ 경력중심의 자기소개서가 면접요청을 받으실 확률이 높습니다.</span></div>
			<InputComp type="textarea" title="자기소개" :maxlength="10000" :rules="{'maxLength':10000}" v-model="data.selfIntroCont" placeholder="상세설명(10,000자 이내)" :readonly="!auth('작성자') && !admModifyYn"/>
		</div>
		
		<!-- 전문분야 -->
		<list-box title="전문분야" type="expert" ref="expert" class="special" desc="※ 최대 5개 선택 가능 / 초과 등록 시 상위 5개만 유지됩니다." v-model="data.expertCdList" key="cd" :mberSeq="data.mberSeq" :admMdf="admModifyYn" v-slot="slot" style="border-top: none; margin-top: 0px;">
			<div class="Board" style="margin-bottom: 0;margin-top: 0;">
				<table class="Board_type2" style="table-layout: auto;">
					<colgroup>
						<col width="*">
					</colgroup>
					<tbody>
						<tr>
							<td class="special">
								<SelectComp class="special" type="select" v-model="slot.item.filter" :defValue="slot.item.cd && slot.item.cd.substr && slot.item.cd.substr(0, 1) || ''" cdId="PRO105" title="전문업종 선택" :disabled="(!auth('작성자') && !admModifyYn)|| state(slot.item, '관리자확정')"/><nbsp/>
								<SelectComp class="special" type="select" v-model="slot.item.cd" cdId="PRO143" :filter="slot.item.filter" title="상세 전문분야 선택" :disabled="(!auth('작성자') && !admModifyYn)|| state(slot.item, '관리자확정')" :rules="[{rule: ruleRequired, args: slot.item}]"/>
								<div class="levelbox special">
									<img src="/images/tec/prf/cancel_btn.png" alt="취소" v-if="auth('작성자') || admModifyYn" @click="$refs.expert.remove(slot.index)"/>
									<template v-if="auth('관리자')  && !admModifyYn">
										<div class="update-time">UPDATE / <span>{{slot.item.mberModDate | date('yyyy.MM.dd HH:mm')}}</span></div>
										<img src="/images/admin/alert.png" alt="정보수정" @click="$refs.expert.comment(slot.index)">
									</template>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</list-box>
      	
		<!-- 직무분야 -->
		<list-box title="직무분야" type="duty" ref="duty" class="special" desc="※ 최대 10개 선택 가능 / 초과 등록 시 상위 10개만 유지됩니다." v-model="data.dutyCdList" :admMdf="admModifyYn" :mberSeq="data.mberSeq" v-slot="slot" >
			<div class="Board" style="margin-bottom: 0;margin-top: 0;">
				<table class="Board_type2" style="table-layout: auto;">
					<colgroup>
						<col width="*">
					</colgroup>
					<tbody>
						<tr>
							<td class="special">
								<SelectComp class="special" type="select" v-model="slot.item.filter" :defValue="slot.item.cd && slot.item.cd.substr && slot.item.cd.substr(0, 2) || ''" cdId="PRO141" title="직무분야 선택" :disabled="(!auth('작성자') && !admModifyYn) || state(slot.item, '관리자확정')"/><nbsp/>
								<SelectComp class="special" type="select" v-model="slot.item.cd" cdId="PRO142" :filter="slot.item.filter" title="상세 직무분야 선택" :disabled="(!auth('작성자') && !admModifyYn)|| state(slot.item, '관리자확정')" :rules="[{rule: ruleRequired, args: slot.item}]"/>
								<div class="levelbox special">
									<img src="/images/tec/prf/cancel_btn.png" alt="취소" v-if="auth('작성자') || admModifyYn" @click="$refs.duty.remove(slot.index)"/>
									<template v-if="auth('관리자') && !admModifyYn">
										<div class="update-time">UPDATE / <span>{{slot.item.mberModDate | date('yyyy.MM.dd HH:mm')}}</span></div>
										<img src="/images/admin/alert.png" alt="정보수정" @click="$refs.duty.comment(slot.index)">
									</template>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</list-box>


		<!-- 직무분야 -->
		<!-- <div class="resume-box job" ref="duty">
			<div class="tit">직무분야<br/><span>※ 중복선택 가능 수행했던 직무를 선택하세요.</span></div>
			<div class="info">
				<div class="Board" style="margin-bottom: 0;margin-top: 0;">
					<table class="Board_type2" style="table-layout: auto;">
						<colgroup>
							<col width="*">
						</colgroup>
						<tbody>
							<tr>
								<td class="tech">
									<SelectComp type="checkbox" v-model="data.dutyCdList" cdId="PRO119" :disabled="!auth('작성자')"/>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div> -->

		<!-- 보유기술 -->
		<list-box title="보유기술" type="techLevel" ref="techLevel" class="tech" v-model="data.techLevelList" key="resumeTechLevelSeq" :mberSeq="data.mberSeq" :admMdf="admModifyYn" v-slot="slot">
			<div class="Board" style="margin-bottom: 0;margin-top: 0;">
				<table class="Board_type2" style="table-layout: auto;">
					<colgroup>
						<col width="*">
					</colgroup>
					<tbody>
						<tr>
							<td class="tech">
								<InputComp v-model="slot.item.techNm" :maxlength="100" classNm="tech" title="기술명" placeholder="기술명(Java, C, DB등)" :readonly="(!auth('작성자') && !admModifyYn)|| state(slot.item, '관리자확정')" :rules="[{rule: ruleRequired, args: slot.item}, {rule:'maxLength', args:100}]"/>
								<div class="levelbox">
									<SelectComp type="radio" title="기술수준" v-model="slot.item.techLevelCd" cdId="PRO125" separator="/" :disabled="!auth('작성자') && !admModifyYn" :rules="[{rule: ruleRequired, args: slot.item}]"/>
									<img src="/images/tec/prf/cancel_btn.png" alt="취소" v-if="auth('작성자') || admModifyYn" @click="$refs.techLevel.remove(slot.index)"/>
									<template v-if="auth('관리자') && !admModifyYn">
										<div class="update-time">UPDATE / <span>{{slot.item.mberModDate | date('yyyy.MM.dd HH:mm')}}</span></div>
										<img src="/images/admin/alert.png" alt="정보수정" @click="$refs.techLevel.comment(slot.index)">
									</template>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</list-box>

		<!-- 학력사항 -->
		<list-box title="학력사항" type="school" ref="school" class="special" :plus="true" v-model="data.schoolList" key="schoolSeq" :mberSeq="data.mberSeq" :admMdf="admModifyYn" v-slot="slot" :mark="true">
			<div class="Board" style="margin-bottom: 0;margin-top: 0;">
				<table class="Board_type2" style="table-layout: auto;">
					<colgroup>
						<col width="*">
					</colgroup>
					<tbody>
						<tr>
							<td style="padding:2px"></td>
						</tr>
						<tr>
							<th class="school">학교명</th>
							<td :class="{school:auth('관리자')}">
								<InputComp title="학교명" v-model="slot.item.schoolNm" classNm="school" :maxlength="300" :readonly="(!auth('작성자') && !admModifyYn) || state(slot.item, '관리자확정,KOSA')"  :rules="[{rule: ruleRequired, args: slot.item}, {rule:'maxLength', args:300}]"/><nbsp/>
								<SelectComp title="졸업상태" type="select" v-model="slot.item.schoolStatusCd" cdId="PRO122" class="school" @change="changeSchoolStatus(slot.item, $event)" :disabled="(!auth('작성자') && !admModifyYn) || state(slot.item, '졸업확정')" :rules="[{rule: ruleRequired, args: slot.item}]"/>
							</td> 
							<th class="schclass">분류</th>
							<td :class="{schclass:auth('관리자')}">
								<SelectComp title="학교분류 선택" type="select" v-model="slot.item.schoolDivCd" cdId="PRO121" tagName="div" class="schclass" :disabled="(!auth('작성자') && !admModifyYn) || state(slot.item, '관리자확정,KOSA')" :rules="[{rule: ruleRequired, args: slot.item}]"/>&nbsp;
								<img class="cancel" src="/images/tec/prf/cancel_btn.png" alt="취소" v-if="(auth('작성자') || admModifyYn)" @click="state(slot.item, '관리자확정,KOSA') == true ? admAlert() : $refs.school.remove(slot.index)"/>
								<img src="/images/admin/alert.png" alt="정보수정" v-if="(auth('관리자') && !admModifyYn)" @click="$refs.school.comment(slot.index)">
							</td>
						</tr>
						<tr>
							<th class="major">전공</th>
							<td class="major">
								<InputComp title="전공" :maxlength="100" :rules="{'maxLength':100}" v-model="slot.item.majorNm" classNm="major" :readonly="(!auth('작성자') && !admModifyYn) || state(slot.item, '관리자확정,KOSA')"/>
								<span class="year">입학년월</span>
								<SelectDate type="MONTH" v-model="slot.item.entYyyymm" title="입학년월" from="Y-50" :to="slot.item.gradYyyymm" :disabled="(!auth('작성자') && !admModifyYn) || state(slot.item, '관리자확정,KOSA')" :rules="[{rule: ruleRequired, args: slot.item}]" :classY="auth('관리자')?'':'year'"/>
							</td> 
							<th class="year">졸업년월</th>
							<td class="major"><SelectDate type="MONTH" v-model="slot.item.gradYyyymm" title="졸업년월" :from="slot.item.entYyyymm" :disabled="(!auth('작성자') && !admModifyYn) || state(slot.item, '졸업확정') || state(slot.item, '재학중')" :rules="[{rule: ruleRequired, args: slot.item}]" :classY="auth('관리자')?'':'year'"/></td>
						</tr>
					</tbody>
				</table>
			</div>
		</list-box>

		<!-- 자격증 -->
		<list-box title="자격증" type="license" ref="license" class="special" v-model="data.licenseList" key="resumeLicenseSeq" :mberSeq="data.mberSeq" :admMdf="admModifyYn" :mark="true">
			<template v-slot:desc><span class="btm"> ※ 등록한 자격증이 등급 산정 기준에 해당하는 경우, ‘자격기준 등급’이 별도 산정됩니다.</span></template>
			<template v-slot="slot">
				<div class="license_search">
					<AutoComplete title="자격증명" :maxlength="100" type="text" v-model="slot.item.licenseNm" :list="code.license" listText="licenseNm" :allowMore="true" @autoComplete="inputLicense(slot.item, $event)" :disabled="(!auth('작성자') && !admModifyYn) || state(slot.item, '관리자확정,KOSA')" :rules="[{rule: ruleRequired, args: slot.item}]" v-slot="slot">
						{{slot.item.licenseNm}} ({{slot.item.issOrgNm}})
					</AutoComplete>
					<div class="license_agency">
						<InputComp title="발행기관명" type="text" :maxlength="100" v-model="slot.item.issOrgNm" :disabled="(!auth('작성자') && !admModifyYn) || state(slot.item, '관리자확정,KOSA') || slot.item.licenseCd || !slot.item.licenseNm" :rules="[{rule: ruleRequired, args: slot.item}, {rule:'maxLength', args:100}]"/><nbsp/>
						취득년월<nbsp/>
						<SelectDate type="MONTH" title="취득년월" v-model="slot.item.acqYyyymm" :disabled="(!auth('작성자') && !admModifyYn) || state(slot.item, '관리자확정,KOSA')" :rules="[{rule: ruleRequired, args: slot.item}]"/>&nbsp;
						<img class="cancel" src="/images/tec/prf/cancel_btn.png" alt="취소" v-if="(auth('작성자') || admModifyYn)" @click="state(slot.item, '관리자확정,KOSA') == true ? admAlert() : $refs.license.remove(slot.index)"/>
						<img src="/images/admin/alert.png" alt="정보수정" v-if="(auth('관리자') && !admModifyYn)" @click="$refs.license.comment(slot.index)">
					</div>
				</div>
			</template>
		</list-box>

		<!-- 교육사항 -->
		<list-box title="교육사항" type="edu" ref="edu" class="special" v-model="data.eduList" key="eduSeq" :mberSeq="data.mberSeq" :admMdf="admModifyYn" v-slot="slot" :mark="true">
			<div class="Board" style="margin-bottom: 0;margin-top: 0;">
				<table class="Board_type2" style="table-layout: auto;">
					<colgroup>
						<col width="*">
					</colgroup>
					<tbody>
						<tr>
							<td style="padding:2px"></td>
						</tr>
						<tr>
							<td class="edu">
								<InputComp title="교육명" type="text" classNm="edu" :maxlength="300" v-model="slot.item.eduNm" :readonly="(!auth('작성자') && !admModifyYn) || state(slot.item, '관리자확정,KOSA')" :rules="[{rule: ruleRequired, args: slot.item}, {rule:'maxLength', args:300}]"/><nbsp/>
								<InputComp title="교육기관명" type="text" classNm="edu" :maxlength="300" v-model="slot.item.eduOrgNm" :readonly="(!auth('작성자') && !admModifyYn) || state(slot.item, '관리자확정,KOSA')" :rules="[{rule: ruleRequired, args: slot.item}, {rule:'maxLength', args:300}]"/>
								시작년월<nbsp/>
								<SelectDate type="MONTH" v-model="slot.item.eduStartYyyymm" title="시작년월" from="Y-50" :to="slot.item.eduEndYyyymm" :disabled="(!auth('작성자') && !admModifyYn) || state(slot.item, '관리자확정,KOSA')" :rules="[{rule: ruleRequired, args: slot.item}]" :classY="auth('관리자')?'':'year'"/>
								종료년월<nbsp/>
								<SelectDate type="MONTH" v-model="slot.item.eduEndYyyymm" title="종료년월" :from="slot.item.eduStartYyyymm" :disabled="(!auth('작성자') && !admModifyYn) || state(slot.item, '관리자확정,KOSA')" :rules="[{rule: ruleRequired, args: slot.item}]" :classY="auth('관리자')?'':'year'"/><nbsp/>
								<img class="edu" src="/images/tec/prf/cancel_btn.png" alt="취소" v-if="auth('작성자') || admModifyYn" @click="$refs.edu.remove(slot.index)"/>
								<img src="/images/admin/alert.png" alt="정보수정" v-if="(auth('관리자') && !admModifyYn)" @click="$refs.edu.comment(slot.index)">
							</td> 
						</tr>
					</tbody>
				</table>
			</div>
		</list-box>

		<!-- 증빙서류 -->
		<list-box title="증빙서류" type="attaFile" ref="attaFile" class="special" v-model="data.attaFileRelList" key="attaFileSeq" :mberSeq="data.mberSeq" :admMdf="admModifyYn" v-slot="slot">
			<div class="license_search docu">
				<AutoComplete title="증빙서류구분" type="text" :maxlength="300" v-model="slot.item.resumeAttaFileDataNm" :list="code.attaFileDivCd" listText="cdNm" :allowMore="true" @autoComplete="inputAttaFileDivCd(slot.item, $event)" :readonly="(!auth('작성자') && !admModifyYn) || state(slot.item, '관리자확정')" :rules="[{rule: ruleRequired, args: slot.item}]"/>
				<div class="license_agency docu">
					<file-select type="file" title="첨부파일" v-model="slot.item.file" :name="slot.item.orgFileNm" @click="clickAttaFile(slot.item, $event)" :disabled="(!auth('작성자') && !admModifyYn) || slot.item.attaFileSeq" :rules="[{rule: ruleRequiredFile, args: slot.item}]"/>
					<div class="levelbox docu">
						<img src="/images/tec/prf/cancel_btn.png" alt="취소" v-if="auth('작성자') || admModifyYn" @click="$refs.attaFile.remove(slot.index)"/>
						<template v-if="(auth('관리자') && !admModifyYn)">
							<div class="update-time">UPDATE / <span>{{slot.item.mberModDate | date('yyyy.MM.dd HH:mm')}}</span></div>
							<img src="/images/admin/alert.png" alt="정보수정" @click="$refs.attaFile.comment(slot.index)">
						</template>
					</div>
				</div>
			</div>
		</list-box>

		<!-- 수상경력 -->
		<div class="resume-box awards" ref="awards">
			<div class="tit">수상경력</div>
			<InputComp type="textarea" title="수상경력" classNm="awards" :maxlength="500" :rules="{'maxLength':500}" v-model="data.awardsCareerCont" placeholder="수상 사항이 있으면, 자유롭게 입력해 주세요.(500자 이내)" :readonly="(!auth('작성자') && !admModifyYn)"/>
		</div>

		<!-- 희망근무조건 -->
		<div class="resume-box req" ref="hopeWork">
			<div class="tit">희망근무조건 <br/><span>※ 중복선택 가능</span></div>
			<div class="info">
				<div class="Board" style="margin-bottom: 0;margin-top: 0;">
					<table class="Board_type2" style="table-layout: auto;">
						<colgroup>
							<col width="*">
						</colgroup>
						<tbody>
							<tr>
								<th class="emptype">사업참여형태</th>
								<td class="emptype"><SelectComp type="checkbox" v-model="data.hopeBizPatCdList" cdId="PRO112" :disabled="!auth('작성자') && !admModifyYn"/>/</td>
								<th class="emptype">고용형태</th>
								<td class="emptype"><SelectComp type="checkbox" v-model="data.hopeEmplPatCdList" cdId="PRO113" :disabled="!auth('작성자') && !admModifyYn"/></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<InputComp type="textarea" title="희망근무조건" classNm="awards" :maxlength="500" :rules="{'maxLength':500}" v-model="data.hopeWorkCondEtcCont" placeholder="추가 희망근무 조건 입력(500자 이내)" :readonly="!auth('작성자') && !admModifyYn"/>
		</div>

		<!-- 재직경력 -->
		<list-box title="재직경력" type="career" ref="career" class="special" v-model="data.careerList" key="careerSeq" :mberSeq="data.mberSeq" :admMdf="admModifyYn" months="workMonthCnt" :totalMonths="workMonthTotCnt">
			<template v-slot:desc><span class="btm">※ 재직 경력의 근무형태 선택 시 ‘IT 정규직’에 해당하는 재직경력만 기술경력으로 인정됩니다.</span></template>
			<template v-slot:top v-if="(auth('관리자') && !admModifyYn)">
				<div class="top">
					<div class="docu" @click="ocr()">건강보험자격득실확인서 첨부파일 PDF, OCR 분석 <img src="/images/admin/show_btn.png" alt="보기"></div>
					<!--div class="ocr">PDF, OCR 인식 내용 보기 <img src="/images/admin/show_btn.png" alt="보기"></div-->
				</div>
			</template>
			<template v-slot="slot">
				<div class="Board" style="margin-bottom: 0;margin-top: 0;">
					<table class="Board_type2" style="table-layout: auto;">
						<colgroup>
							<col width="*">
						</colgroup>
						<tbody>
							<tr>
								<td style="padding:8px"></td>
							</tr>
							<tr>
								<th>회 사 명</th>
								<td class="career">
									<InputComp title="회사명" type="text" :maxlength="300" v-model="slot.item.companyNm" classNm="cpname" :readonly="(!auth('작성자') && !admModifyYn) || state(slot.item, '관리자확정,KOSA')" :rules="[{rule: ruleRequired, args: slot.item}, {rule:'maxLength', args:300}]"/><nbsp/>
									<SelectComp title="산업분야" type="select"  v-model="slot.item.indtypeClassCd" cdId="PRO105" class="cpname" :disabled="(!auth('작성자') && !admModifyYn) || state(slot.item, '관리자확정')"/><nbsp/>
									<SelectComp title="근무형태" type="select" v-model="slot.item.workPatCd" cdId="PRO123" class="cpname" :disabled="(!auth('작성자') && !admModifyYn) || state(slot.item, '관리자확정')" :rules="[{rule: ruleRequiredNew, args: slot.item}]"/><nbsp/>
									<InputComp title="직급/직책" type="text" :maxlength="100" :rules="{'maxLength':100}" v-model="slot.item.positionNm" classNm="position" :readonly="(!auth('작성자') && !admModifyYn)"/><nbsp/>
									<img class="cancel" src="/images/tec/prf/cancel_btn.png" alt="취소" v-if="auth('작성자') || admModifyYn" @click="state(slot.item, '관리자확정,KOSA') == true ? admAlert() : $refs.career.remove(slot.index)"/>
									<img src="/images/admin/alert.png" alt="정보수정" v-if="(auth('관리자') && !admModifyYn)" @click="$refs.career.comment(slot.index)">
								</td>
							</tr>
							<tr>
								<th class="charge">담당업무</th>
								<td class="charge">
									<InputComp title="담당업무" classNm="charge" type="text" :maxlength="300" :rules="{'maxLength':300}" v-model="slot.item.assigWorkNm" :readonly="(!auth('작성자') && !admModifyYn)"/><nbsp/>
									<p>재직기간</p><nbsp/>
									<SelectDate type="MONTH" v-model="slot.item.workStartYyyymm" title="재직시작년월" from="Y-50" :to="slot.item.workEndYyyymm" :disabled="(!auth('작성자') && !admModifyYn) || state(slot.item, '관리자확정,KOSA')" :rules="[{rule: ruleRequired, args: slot.item}]" :classY="auth('관리자') ? '' : 'year'"/><nbsp/>
									<p>-</p><nbsp/>
									<SelectDate type="MONTH" v-model="slot.item.workEndYyyymm" title="재직종료년월" :from="slot.item.workStartYyyymm" :disabled="(!auth('작성자') && !admModifyYn) || state(slot.item, '퇴직확정') || state(slot.item, '재직중')" :rules="[{rule: ruleRequired, args: slot.item}]" :classY="auth('관리자') ? '' : 'year'"/><nbsp/>
									<SelectComp title="재직중" type="yn" v-model="slot.item.workingYn" @change="checkDoing($event, slot.item, 'workEndYyyymm', 'yyyyMM')" :disabled="(!auth('작성자') && !admModifyYn) || state(slot.item, '퇴직확정')"/>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</template>
		</list-box>

		<!-- 프로젝트 경력 -->
		<list-box title="프로젝트 경력" type="project" ref="project" class="special" v-model="data.projectList" key="resumeProjectSeq" :mberSeq="data.mberSeq" :admMdf="admModifyYn" months="joinMonthCnt" :totalMonths="joinMonthTotCnt">
			<template v-slot:desc><span class="btm">※ 프로젝트 경력에 입력하신 프리랜서 경력은 기술경력으로 인정됩니다.</span></template>
			<template v-slot="slot">
				<div class="Board" style="margin-bottom: 0;margin-top: 0;">
					<table class="Board_type2" style="table-layout: auto;">
						<colgroup>
							<col width="*">
						</colgroup>
						<tbody>
							<tr><td style="padding:8px"></td></tr>
							<tr>
								<td class="project">
									<InputComp classNm="prjname" type="text" title="프로젝트명" :maxlength="300" v-model="slot.item.projectNm" placeholder="프로젝트명" :readonly="(!auth('작성자') && !admModifyYn) || state(slot.item, '관리자확정,KOSA')" :rules="[{rule: ruleRequired, args: slot.item}, {rule:'maxLength', args:300}]"/><nbsp/>
									<p>시작년월</p><nbsp/>
									<SelectDate type="MONTH" v-model="slot.item.joinStartYyyymm" title="시작년월" from="Y-50" :to="slot.item.joinEndYyyymm" :disabled="(!auth('작성자') && !admModifyYn) || state(slot.item, '관리자확정,KOSA')" :rules="[{rule: ruleRequired, args: slot.item}]" :classY="auth('관리자') ? '' : 'year'"/><nbsp/>
									<p>종료년월</p><nbsp/>
									<SelectDate type="MONTH" v-model="slot.item.joinEndYyyymm" title="종료년월" :from="slot.item.joinStartYyyymm" :disabled="(!auth('작성자') && !admModifyYn) || state(slot.item, '참여종료확정') || state(slot.item, '참여중')" :rules="[{rule: ruleRequired, args: slot.item}]" :classY="auth('관리자') ? '' : 'year'"/><nbsp/>
									<SelectComp type="yn" v-model="slot.item.projectWorkingYn" title="진행중" @change="checkDoing($event, slot.item, 'joinEndYyyymm', 'yyyyMM')" :disabled="(!auth('작성자') && !admModifyYn) || state(slot.item, '참여종료확정')"/><nbsp/>
									<img class="cancel" src="/images/tec/prf/cancel_btn.png" alt="취소" v-if="auth('작성자') || admModifyYn" @click="state(slot.item, '관리자확정,KOSA') == true ? admAlert() : $refs.project.remove(slot.index)"/>
									<img src="/images/admin/alert.png" alt="정보수정" v-if="(auth('관리자') && !admModifyYn)" @click="$refs.project.comment(slot.index)">
								</td>
							</tr>
							<tr>
								<td :class="{prjname : auth('관리자'), project:auth('작성자')}">
									<InputComp classNm="prjname" title="고객사명" :maxlength="300" :rules="{'maxLength':300}" type="text" v-model="slot.item.clientNm" :readonly="(!auth('작성자') && !admModifyYn) || state(slot.item, '관리자확정,KOSA')"/><nbsp/>
									<SelectComp class="prj" type="select" v-model="slot.item.clientIndtypeClassCd" cdId="PRO105" title="고객사 분류" :disabled="(!auth('작성자') && !admModifyYn) || state(slot.item, '관리자확정')"/><nbsp/>
									<InputComp classNm="prjname" title="수행사명" :maxlength="300" :rules="{'maxLength':300}" type="text" v-model="slot.item.workCompanyNm" :readonly="(!auth('작성자') && !admModifyYn) || state(slot.item, '관리자확정,KOSA')"/><nbsp/>
									<SelectComp class="prj" type="select" v-model="slot.item.workPatCd" cdId="PRO123" title="근무형태" :disabled="(!auth('작성자') && !admModifyYn) || state(slot.item, '관리자확정')" :rules="[{rule: ruleRequiredNew, args: slot.item}]"/>
								</td>
							</tr>
							<tr>
								<td :class="{perform: auth('관리자'), project:auth('작성자')}">
									<InputComp classNm="task" type="text" title="수행업무" :maxlength="300" :rules="{'maxLength':300}" placeholder="수행업무" v-model="slot.item.exeWorkCont" :readonly="!auth('작성자') && !admModifyYn"/><nbsp/>
									<InputComp classNm="duty" type="text" title="수행직무" :maxlength="300" :rules="{'maxLength':300}" placeholder="수행직무" v-model="slot.item.exeDutyCont" :readonly="!auth('작성자') && !admModifyYn"/><nbsp/>
									<SelectComp class="prj" type="select" v-model="slot.item.joinDivCd" cdId="PRO124" title="참여구분" :disabled="!auth('작성자') && !admModifyYn"/>
								</td>
							</tr>
							<tr>
								<td :class="{devp: auth('관리자'), project:auth('작성자')}">
									<InputComp classNm="devp" type="text" title="개발환경기종" :maxlength="100" :rules="{'maxLength':100}" placeholder="개발환경기종" v-model="slot.item.devServer" :readonly="!auth('작성자') && !admModifyYn"/><nbsp/>
									<InputComp classNm="devp" type="text" :maxlength="100" title="개발환경OS" placeholder="개발환경OS" :rules="{'maxLength':100}" v-model="slot.item.devOs" :readonly="!auth('작성자') && !admModifyYn"/><nbsp/>
									<InputComp classNm="devp" type="text" :maxlength="100" title="개발환경언어" placeholder="개발환경언어" :rules="{'maxLength':100}" v-model="slot.item.devLang" :readonly="!auth('작성자') && !admModifyYn"/><nbsp/>
									<InputComp classNm="devp" type="text" title="개발환경DBMS" :maxlength="100" :rules="{'maxLength':100}" placeholder="개발환경DBMS" v-model="slot.item.devDbms" :readonly="!auth('작성자') && !admModifyYn"/><nbsp/>
									<InputComp classNm="devp" type="text" title="개발환경TOOL" :maxlength="200" :rules="{'maxLength':200}" placeholder="개발환경TOOL" v-model="slot.item.devTool" :readonly="!auth('작성자') && !admModifyYn"/><nbsp/>
									<InputComp classNm="devp" type="text" title="개발환경통신" :maxlength="100" :rules="{'maxLength':100}" placeholder="개발환경통신" v-model="slot.item.devComm" :readonly="!auth('작성자') && !admModifyYn"/>
								</td>
							</tr>
							<tr>
								<td :class="{explan: auth('관리자'), project:auth('작성자')}">
									<InputComp type="textarea" title="프로젝트 상세설명" :maxlength="500" :rules="{'maxLength':500}" v-model="slot.item.projectDtlDesc" placeholder="상세설명(500자 이내)" :readonly="!auth('작성자') && !admModifyYn"/>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</template>
		</list-box>
	</div>
</template>

<script>
import fileSelect from "@/components/FileSelect.vue";
import listBox from "@/components/highpro/ResumeListBox.vue";
export default {
	components: { fileSelect, listBox },
	props: {
		tecMberSeq: {},
		admMdf: {},
	},
	data(){
		return {
			profileImg: null,
			data: {},
            code: {
                attaFileDivCd : []
            },
			temp: {},
			admModifyYn: this.admMdf != undefined ? this.admMdf : false,
			workMonthTotCnt :'',
			joinMonthTotCnt : '',
			stepItem : this.auth('관리자') ? 2 : 1,
			kosaData : {},
		 }
	},
	mounted(){
		this.$.httpPost('/api/mem/prf/getLicense')
            .then(res => {
                // console.log('PRF101M01', 'getLicense', res.data);
                this.code.license = res.data.list;
            })
        this.$.httpPost('/api/mem/prf/getAttaFileDataNm')
            .then(res => {
                this.code.attaFileDivCd = res.data.list;
            });
        this.search();
	},
	methods: {
        search(){
			// console.log('PRF101M01', '이력서 조회', '/api/mem/prf/getResume');
            this.$.httpPost('/api/mem/prf/getResume', { tecMberSeq : this.tecMberSeq })
                .then(res => {
                    // console.log('PRF101M01', 'getResume', res.data);
                    
                    var data = {};
                    if(res.data.resumeTmpSaveCont && confirm('작성중인 이력서가 있습니다. 기존 정보를 불러오시겠습니까?\n작성일시: ' + this.$format.date(res.resumeTmpSaveDate, 'date').format('yyyy.MM.dd HH:mm'))){
                        data = JSON.parse(res.data.resumeTmpSaveCont);
						data.attaFileRelList = [];
                    } else {
                        data = res.data;
                        delete data.resumeTmpSaveCont;
                    }

                    this.data = data;

					if(this.auth('관리자')){
						this.workMonthTotCnt = this.data.careerList.reduce((acc, item) => acc + item.workMonthCnt, 0);
						this.joinMonthTotCnt = this.data.projectList.reduce((acc, item) => acc + item.joinMonthCnt, 0);
					}
				
                    window.scrollTo(0, 0);
                    // console.log('PRF101M01', 'getResume result', this.data);
                }).catch(this.$.httpErrorCommon);
        },
		saveProfile(file){
			this.$.fileUpload('IMG_PDF_DOC', [file], '/api/mem/prf/saveProfile' )
				.then(() => {
                    // console.log('PRF101M01', 'saveProfile', res.data);
                }).catch(this.$.httpErrorCommon);
		},
        excelUpload(file){
			if(confirm('파일을 업로드하시겠습니까?')) {
				// console.log('file', file);
                this.$.fileUpload('ALL', [file], '/api/mem/prf/uploadResumeExcel')
                    .then(res => {
                        //console.info('PRF101M01 excelUpload : v1.0.0.0', res);
						this.$.popup('/tec/prf/PRF101P05');
                        
						if(res.data.수상경력 != null ){
							this.data.awardsCareerCont    = res.data.수상경력.trim();
						}
						if(res.data.자기소개 != null ){
							this.data.selfIntroCont       = res.data.자기소개.trim();
						}
						if(res.data.추가희망근무조건 != null ){
							this.data.hopeWorkCondEtcCont = res.data.추가희망근무조건.trim();
						}

                        //교육
                        for(var i1 in res.data.교육사항){
                            var edu = {};
                            edu.eduNm               = res.data.교육사항[i1]['교육명'].trim();
                            edu.eduOrgNm            = res.data.교육사항[i1]['교육기관명'].trim();
                            edu.eduStartYyyymm      = res.data.교육사항[i1]['시작년월'].slice(0, 6);
                            edu.eduEndYyyymm        = res.data.교육사항[i1]['종료년월'].slice(0, 6);
                            this.$refs.edu.add(edu);
                        }
                        //기술수준
                        for(var i2 in res.data.기술수준){
                            var techLevel = {};
                            techLevel.techNm        = res.data.기술수준[i2]['기술명'].trim();
                            techLevel.techLevelCd   = res.data.기술수준[i2]['기술수준'].slice(0, 1);
                            this.$refs.techLevel.add(techLevel);
                        }
                        //자격증
                        for(var i3 in res.data.자격증){
                            var license = {};
                            var sp = res.data.자격증[i3]['자격증명'].split('-');
                            license.licenseCd   = sp[0];
                            license.licenseNm   = sp[1];
                            license.issOrgNm    = sp[2];
                            license.acqYyyymm   = res.data.자격증[i3]['취득년월'].slice(0, 6);
                            this.$refs.license.add(license);
                        }
                        //재직경력
                        for(var i4 in res.data.재직경력){
                            var career = {};
                            career.companyNm         = res.data.재직경력[i4]['회사명'].trim();
                            career.positionNm        = res.data.재직경력[i4]['직위'].trim();
                            career.indtypeClassCd    = res.data.재직경력[i4]['기업구분'].slice(0, 1);
                            career.workPatCd         = res.data.재직경력[i4]['근무형태'].slice(0, 2);
                            career.assigWorkNm       = res.data.재직경력[i4]['담당업무'].trim();
                            career.workStartYyyymm   = res.data.재직경력[i4]['입사년월'].slice(0, 6);
                            career.workEndYyyymm     = res.data.재직경력[i4]['퇴사년월'].slice(0, 6);
                            if(career.workStartYyyymm && !career.workEndYyyymm){
                                //입사년월은 있는데 퇴사년월이 없을 경우 재직중 처리한다.
                                career.workingYn    = 'Y';
                                career.workEndYyyymm       = new Date().format("yyyyMM");
                            } else {
                                career.workingYn    = 'N';
                            }
                            this.$refs.career.add(career);
                        }
                        //전문분야
                        for(var i5 in res.data.전문분야){
                            var expert = {};
                            expert.filter   = res.data.전문분야[i5]['전문분야 분류'].slice(0, 1);
                            expert.cd       = res.data.전문분야[i5]['전문분야 상세'].slice(0, 4);
                            if(expert.cd.indexOf(expert.filter) != 0) {
                                //console.error('excelUpload', '전문분야', i5, expert);
                                expert.cd = '';
                            }
                            this.$refs.expert.add(expert);
                        }
                        //기술경력
                        for(var i6 in res.data.프로젝트경력){
                            var project = {};
                            project.projectNm            = res.data.프로젝트경력[i6]['프로젝트명'].trim();
                            project.joinStartYyyymm      = res.data.프로젝트경력[i6]['참여시작년월'].slice(0, 6);
                            project.joinEndYyyymm        = res.data.프로젝트경력[i6]['참여종료년월'].slice(0, 6);
                            project.clientNm             = res.data.프로젝트경력[i6]['고객사명'].trim();
                            project.clientIndtypeClassCd = res.data.프로젝트경력[i6]['고객사분류'].slice(0, 1);
                            project.workCompanyNm        = res.data.프로젝트경력[i6]['근무사명'].trim();
                            project.workPatCd            = res.data.프로젝트경력[i6]['근무형태'].slice(0, 2);
                            project.exeWorkCont          = res.data.프로젝트경력[i6]['수행업무'].trim();
                            project.exeDutyCont          = res.data.프로젝트경력[i6]['수행직무'].trim();
							project.joinDivCd            = res.data.프로젝트경력[i6]['참여구분'].slice(0, 2);
                            project.projectDtlDesc       = res.data.프로젝트경력[i6]['프로젝트\n상세설명'].trim();
                            project.devServer            = res.data.프로젝트경력[i6]['개발환경\n기종'].trim();
                            project.devOs                = res.data.프로젝트경력[i6]['개발환경\nOS'].trim();
                            project.devLang              = res.data.프로젝트경력[i6]['개발환경\n언어'].trim();
                            project.devTool              = res.data.프로젝트경력[i6]['개발환경\nTOOL'].trim();
                            project.devDbms              = res.data.프로젝트경력[i6]['개발환경\nDBMS'].trim();
                            project.devComm              = res.data.프로젝트경력[i6]['개발환경\n통신'].trim();
                            if(project.joinStartYyyymm && !project.joinEndYyyymm){
                                //참여시작년월은 있는데 참여종료년월이 없을 경우 프로젝트 진행중 처리한다.
                                project.projectWorkingYn    = 'Y';
                                project.joinEndYyyymm       = new Date().format("yyyyMM");
                            } else {
                                project.projectWorkingYn    = 'N';
                            }
                            this.$refs.project.add(project);
                        }
                        //학력
                        for(var i7 in res.data.학력사항){
                            var school = {};
                            school.schoolDivCd       = res.data.학력사항[i7]['학력구분'].slice(0, 2);
                            school.schoolNm          = res.data.학력사항[i7]['학교명'].trim();
                            school.schoolStatusCd    = res.data.학력사항[i7]['학력상태'].slice(0, 2);
                            school.majorNm           = res.data.학력사항[i7]['전공명'].trim();
                            school.entYyyymm         = res.data.학력사항[i7]['입학년월'].slice(0, 6);
                            school.gradYyyymm        = res.data.학력사항[i7]['졸업년월'].slice(0, 6);
                            this.$refs.school.add(school);
                        }
                        //직무분야
						for(var i8 in res.data.직무분야){
                            var duty = {};
                            duty.filter   = res.data.직무분야[i8]['직무분야 분류'].slice(0, 2);
                            duty.cd       = res.data.직무분야[i8]['직무분야 상세'].slice(0, 5);
                            if(duty.cd.indexOf(duty.filter) != 0) {
                                //console.error('excelUpload', '직무분야', i8, duty);
                                duty.cd = '';
                            }
                            this.$refs.duty.add(duty);
                        }

                        // var temp = [];
                        // for(var k1 in res.data.직무분야){
                        //     if(res.data.직무분야[k1] == 'true'){
                        //         temp.push(k1.slice(0, 2));
                        //     }
                        // }
                        // this.data.dutyCdList = temp.join(',');


                        //희망고용형태
						var temp = [];
                        for(var k2 in res.data.희망고용형태){
                            if(res.data.희망고용형태[k2] == 'true'){
                                temp.push(k2.slice(0, 2));
                            }
                        }
                        this.data.hopeEmplPatCdList = temp.join(',');

                        //희망사업참여형태
                        temp = [];
                        for(var k3 in res.data.희망사업참여형태){
                            if(res.data.희망사업참여형태[k3] == 'true'){
                                temp.push(k3.slice(0, 2));
                            }
                        }
                        this.data.hopeBizPatCdList = temp.join(',');
                        this.$forceUpdate();
					}).catch(err => {
					    this.temp.excelFile = null;
                    	this.$.httpErrorCommon(err);
					});
            } else {
                this.temp.excelFile = null;
            }
        },
        searchKOSA(){
            // this.$.popup('/tec/prf/PRF101P01')
                // .then(res => {
				this.$.httpPost('/api/mem/prf/getKOSA', this.kosaData)
				.then(res => {
					res = res.data;
                    // console.log('PRF101M01', 'searchKOSA', res);
                    if(res){
                        //교육
                        for(var i1 in res.education){
                            var edu = {};
                            edu.kosaIdenti          = res.education[i1].educationCode;
                            edu.eduNm               = res.education[i1].educationName.trim();
                            edu.eduOrgNm            = res.education[i1].educationOrg.trim();
                            edu.eduStartYyyymm      = res.education[i1].educationStartDate.substring(0, 6);
                            edu.eduEndYyyymm        = res.education[i1].educationEndDate.substring(0, 6);
                            edu.kosaScrapStatusCd   = res.education[i1].approvalStatus == '3' ? '01' : '00';
                            this.$refs.edu.add(edu);
                        }
                        //학력
                        for(var i2 in res.scholar){
                            var school = {}
                            school.kosaIdenti        = res.scholar[i2].scholarNo;
                            school.schoolDivCd       = res.scholar[i2].schoolDivCd;
                            school.schoolNm          = res.scholar[i2].schoolNm.trim();
                            school.schoolStatusCd    = '00';
                            school.majorNm           = res.scholar[i2].schoolDeptName.trim();
                            school.entYyyymm         = res.scholar[i2].schoolEnterDate.substring(0, 6);
                            school.gradYyyymm        = res.scholar[i2].schoolFinishDate.substring(0, 6);
                            school.kosaScrapStatusCd = res.scholar[i2].approvalStatus == '3' ? '01' : '00';
                            this.$refs.school.add(school);
                        }
                        //기술경력
                        for(var i3 in res.skillCareer){
                            var project = {};
                            project.kosaIdenti           = res.skillCareer[i3].skillCareerNo;
                            project.projectNm            = res.skillCareer[i3].participateProjectName.trim();
                            project.joinStartYyyymm      = res.skillCareer[i3].participateStartDate.substring(0, 6);
                            project.joinEndYyyymm        = res.skillCareer[i3].participateEndDate.substring(0, 6);
                            project.projectWorkingYn     = 'N';
                            project.clientNm             = res.skillCareer[i3].orderOrgNm.trim();
                            project.workCompanyNm        = res.skillCareer[i3].companyNm.trim();
                            project.workPatCd            = res.skillCareer[i3].position == '프리랜서' ? '02' : '';
                            project.exeWorkCont          = res.skillCareer[i3].dutySkill.trim();
                            project.exeDutyCont          = res.skillCareer[i3].ncsDutyDiv1Nm;
                            project.kosaScrapStatusCd    = res.skillCareer[i3].approvalStatus == '3' ? '01' : '00';
                            this.$refs.project.add(project);
                        }
                        //자격증
                        for(var i4 in res.skillCert){
                            var license = {};
                            license.kosaIdenti        = res.skillCert[i4].skillCertNo;
                            license.licenseNm         = res.skillCert[i4].certItem.trim();
                            license.issOrgNm          = res.skillCert[i4].certPubNm.trim();
                            license.acqYyyymm         = res.skillCert[i4].passDate.substring(0, 6);
                            license.kosaScrapStatusCd = res.skillCert[i4].approvalStatus == '3' ? '01' : '00';

                            for(var j4 in this.code.license){
                                if(res.skillCert[i4].certPubNm == this.code.license[j4].licenseNm){
                                    license.licenseCd = this.code.license[j4].licenseCd;
                                    license.issOrgNm  = this.code.license[j4].issOrgNm;
                                }
                            }
                            this.$refs.license.add(license);
                        }
                        //재직경력
                        for(var i5 in res.workCareer){
                            var career = {};
                            career.kosaIdenti        = res.workCareer[i5].workCareerNo;
                            career.companyNm         = res.workCareer[i5].companyNm.trim();
                            career.positionNm        = res.workCareer[i5].position.trim();
                            career.workPatCd         = "01";
                            career.assigWorkNm       = res.workCareer[i5].ncsDutyDiv2Nm;
                            career.workStartYyyymm   = res.workCareer[i5].workStartDate.substring(0, 6);
                            career.workEndYyyymm     = res.workCareer[i5].workEndDate.substring(0, 6);
                            career.workingYn         = "N";
                            career.kosaScrapStatusCd = res.workCareer[i5].approvalStatus == '3' ? '01' : '00';
                            this.$refs.career.add(career);
                        }
                        this.$forceUpdate();
                    }
                });
        },
        ocr(){
			this.$router.push({name:'MEM910M03', query:{ tecMberSeq : this.tecMberSeq, resumeAttaFileDivCd : '03' }});
        },

        ruleRequired(v, item, msg){
            if(!v && (this.auth('작성자') || this.admModifyYn)){
                for(var key in item){
                    if(key.indexOf('_') != 0 && item[key]){
                        if(item[key] instanceof Error){
                            // console.log('', 'ruleRequired', key, item[key].message);
                        } else {
                            var row = this.rowInfo(item);
                            return msg || ('항목을 확인해 주세요.' + (row.no ? '\n· 위치: ' + row.section + ' ' + row.no + '번째' : ''))
                        }
                    }
                }
            }
            return true;
        },
        ruleRequiredNew(v, item, msg){	// 신규 입력 행만 필수 (PK 가 있는 기존 데이터는 확정 시 수정이 불가하므로 제외)
            if(item && (item.careerSeq || item.resumeProjectSeq)) return true;
            return this.ruleRequired(v, item, msg);
        },
		ruleRequiredFile(v, item, msg){
            if(!v && !item.attaFileSeq && (this.auth('작성자') || this.admModifyYn)){
                // console.log('', 'ruleRequiredFile', v, item, msg);
                for(var key in item){
                    if(key.indexOf('_') != 0 && item[key]){
                        if(item[key] instanceof Error){
                            // console.log('', 'ruleRequired', key, item[key].message);
                        } else {
                            return msg || '항목 입력 시 필수 입력입니다.'
                        }
                    }
                }
            }
            return true;
        },
        rowInfo(item){	// item이 data의 어느 목록 몇 번째인지 역추적 (목록 소속이 아니면 no = 0)
            var sectionNm = {
                expertCdList    : '전문분야',   dutyCdList  : '직무분야',
                techLevelList   : '보유기술',   schoolList  : '학력사항',
                licenseList     : '자격증',     eduList     : '교육사항',
                attaFileRelList : '증빙서류',   careerList  : '재직경력',
                projectList     : '프로젝트 경력',
            };
            if(item && typeof item == 'object'){
                for(var key in this.data){
                    if(Array.isArray(this.data[key])){
                        var i = this.data[key].indexOf(item);
                        if(i >= 0) return { no: i + 1, section: sectionNm[key] || '' };
                    }
                }
            }
            return { no: 0, section: '' };
        },

        changeSchoolStatus(item, event){
            // console.log('PRF101M01', 'changeSchoolStatus', item, event, event.target.value);
            item.statusChange = true;
            item.schoolStatusCd = event.target.value;
            if(this.state(item, '재학중')){
                item.gradYyyymm = '';
            }
        },
        inputLicense(item, value){
            // console.log('PRF101M01', 'inputLicense', item, value)
            if(value && value.issOrgNm){
                item.issOrgNm  = value.issOrgNm;
                item.licenseCd = value.licenseCd;
            } else {
                if(value){
                    alert('정해진 목록이 아닌 직접입력한 자격증은 자동 등급계산에 적용되지 않을 수 있습니다.');
                }
                item.licenseCd = '';
                item.issOrgNm = '';
            }
            //this.$forceUpdate()
        },
        inputAttaFileDivCd(item, value){
            // console.log('PRF101M01', 'inputAttaFileDivCd', item, value)
            if(value && value.cd){
                item.resumeAttaFileDivCd  = value.cd;
                item.resumeAttaFileDataNm = value.cdNm;
            } else {
                item.resumeAttaFileDivCd  = '';
                item.resumeAttaFileDataNm = '';
            }
            this.$forceUpdate()
        },
        clickAttaFile(item){
            // console.log('clickAttaFile', item, event)
            if(item.attaFileSeq){
                var param = {
                    tecMberSeq : this.data.mberSeq,
                    attaFileSeq: item.attaFileSeq
                }
                this.$.fileDownload('/api/mem/prf/downResumeFile', param)
					.catch(this.$.httpErrorCommon);
            }
        },
		checkAdminComment(){
			var count = 0;
			if(!this.data.mberSeq){
				alert("조회 결과가 없습니다.")
				return false;
			}

			for(var ref in this.$refs){
				if(this.$refs[ref].checkAdminComment){
					var check = this.$refs[ref].checkAdminComment();
					if(check === false){
						alert("작성중인 수정요청 내용이 있습니다.")
						this.$.focus(this.$refs[ref]);
						return false;
					} else {
						count += check;
					}
				}
			}
			return count;
		},
        checkDoing(event, item, key, format){
            // console.log('checkDoing', event.target.checked, item, key, format)
            if(event.target.checked){
                item[key] = new Date().format(format);
                // console.log('checkDoing', item[key])
            }
        },
        state(item, checks){
            var checkArr = checks.toUpperCase().split(',');
            if(checkArr.indexOf('관리자확정'    ) >= 0 && item.admCfmDate) return true;
            if(checkArr.indexOf('KOSA'          ) >= 0 && ['00', '01'].indexOf(item.kosaScrapStatusCd) >= 0) return true;
            if(checkArr.indexOf('KOSA확정'      ) >= 0 && item.kosaScrapStatusCd == '01') return true;
            //학력
            if(checkArr.indexOf('재학중'        ) >= 0 && ['02','03'].indexOf(item.schoolStatusCd) >= 0) return true;
            if(checkArr.indexOf('졸업확정'      ) >= 0 && this.state(item, '관리자확정,KOSA') && ['02','03'].indexOf(item.schoolStatusCd) < 0 && !item.statusChange && ['00','01', '04'].indexOf(item.cfmSchoolStatusCd) >= 0) return true;
            //재직경력
            if(checkArr.indexOf('근무중'        ) >= 0 && item.workingYn == 'Y') return true;
            if(checkArr.indexOf('퇴직확정'      ) >= 0 && this.state(item, '관리자확정,KOSA') && item.workingYn != 'Y' && !item.statusChange && item.cfmWorkingYn == 'N') return true;
            //업무경력(프로젝트)
            if(checkArr.indexOf('참여중'        ) >= 0 && item.projectWorkingYn == 'Y') return true;
            if(checkArr.indexOf('참여종료확정'  ) >= 0 && this.state(item, '관리자확정,KOSA') && item.projectWorkingYn != 'Y' && !item.statusChange && item.cfmProjectWorkingYn == 'N') return true;
            return false;
        },
        auth(checks){
            var checkArr = checks.toUpperCase().split(',');
            //console.log('PRF101M01', 'auth', checkArr, this.data, this.$store.state.userInfo, this.$store.getters);
            //console.log('PRF101M01', 'auth', 'SELF', checkArr.indexOf('SELF' ), this.data.mberSeq == this.$store.state.userInfo.mberSeq);
            if(checkArr.indexOf('작성자' ) >= 0 && this.data.mberSeq == this.$store.state.userInfo.mberSeq) return true;
            //console.log('PRF101M01', 'auth', 'ADMIN', checkArr.indexOf('ADMIN' ), this.$store.getters.isAdmin);
            if(checkArr.indexOf('관리자') >= 0 && this.$store.getters.isAdmin)  return true;
            if(checkArr.indexOf('등록')   >= 0 && this.data.regYn == 'Y')  return true;
            return false;
        },

		admAlert() {
			alert("기술등급이 확정된 상태이므로, 삭제하실 수 없습니다.");
		},

		admModify() {
			this.admModifyYn = this.admModifyYn == false ? true : false;

			var params = {
				tecMberSeq : this.tecMberSeq,
				// caller : {
				// 	name: this.$route.name,
				// 	params: this.input,
				// }
			}
			
			this.$router.push({name: 'MEM910M04', params });
		},

		resmAtchPup(){
			this.$.popup('/adm/mem/MEM910P03', this.data);
		},

		resmFileUpload(file){
			if(confirm('"'+file.name+'" 파일을 업로드하시겠습니까?')) {
				const uploadData = {
					targetMberSeq: this.data.mberSeq
				};

				this.$.fileUpload('ALL', [file], '/api/mem/prf/uploadResmAgncFile',uploadData)
                    .then(() => {
						this.$.popup('/tec/prf/PRF101P04')
						.then(res => {
							if(!res) {
								this.data.lastAttaFileNm = this.temp.resmFile.name;
								this.data.lastAttaFileRegDate = new Date().format('yyyy.MM.dd');
								this.search();
							}
						})
						return;
					})
                    .catch(err => {
					    this.temp.resmFile = null;
                    	this.$.httpErrorCommon(err);
					});
            } else {
                this.temp.resmFile = null;
            }
		},

		changeStep(num) {
			this.stepItem = num;
		},

		/* 이력서 등록대행 다운로드 */
		clickAttaFileAdm(){
            // console.log('clickAttaFile', item, event)
			var param = {
				tecMberSeq : this.data.mberSeq,
				attaFileSeq: this.data.lastAttaFileSeq
			}
			this.$.fileDownload('/api/mem/adm/prf/downResmAgncFile', param, {}, 'POST', true)
				.then(()=> {
					this.getResmAtchFiles();
				})
				.catch(this.$.httpErrorCommon);
        },

		delResmAgncFile(fileSeq) {
			if(confirm('파일을 삭제하시겠습니까?')) {
				this.$.httpPost('/api/mem/prf/deleteResmAgncFile', {attaFileSeq : fileSeq})
					.then(res => {

						if(res) {
							this.data.lastAttaFileNm = res.data.lastAttaFileNm;
							this.data.lastAttaFileRegDate = res.data.lastAttaFileRegDate;
							this.data.lastAttaFileSeq = res.data.lastAttaFileSeq;
							alert("삭제가 완료되었습니다.");
							this.search();
						}
					})
			}
		}
	}
}
</script>